module.exports = __webpack_public_path__ + "assets/retina_TrapezoidHarmMeanDetailed.be606fc1ba9165621e4bcbf76439b72b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_TrapezoidHarmMeanDetailed.png
// module id = 748
// module chunks = 0